if (!customElements.get('coco-shuffle')) {
  class CocoShuffle extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.selectedSize = null;
      this.selectedLength = null;
      this.readyToAdd = false;
      this.gender = this.dataset.gender
      this.colorLabel = this.dataset.colorLabel?.toLowerCase()?.trim() || '';
      this.indexPrefix = this.dataset.prefix;
      this.mainSelect = this.querySelector('[data-main-select]');
      this.tagColor = this.dataset.tagColor;
      this.saleColor = this.dataset.saleColor;
      this.tagPriceColor = this.dataset.tagPriceColor;
      this.saleWeight = this.dataset.saleWeight;
      this.tagsForTagPriceColor = this.dataset.tagsForTagPriceColor;
      this.expressPaymentWrapper = this.querySelector('[data-express-payment-wrapper]');
    }
    
    connectedCallback() {
      this.products = JSON.parse(this.dataset.productsJson.replace("}]},]", "}]}]")
        .replaceAll('%27', '&apos;')
        .replaceAll('%22', '&quot;')
        );
      this.baseProduct = this.products.find(product => product.tags.find(x => x === 'base_product')) ?? null;
      this.selectedProduct = this.products.length > 1 ? this.products.find(({ handle }) => window.location.pathname.endsWith(`/products/${handle}`)) : this.products[0];
      this.customer = this.dataset.customerId || false;
      const initialProductId = this.querySelector('input[data-product-id]:checked')?.dataset?.productId;
      if (this.selectedProduct?.id === this.baseProduct?.id || !this.selectedProduct) {
        this.selectedProduct = this.products.find(x => x.id === initialProductId);
      }
      
      this.populateSelectedProductImages = populateSelectedProductImages.bind(this);
      this.populateSelectedProductOptions = populateSelectedProductOptions.bind(this);
      this.populateSelectedProductPrice = populateSelectedProductPrice.bind(this);
            
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="add-to-cart"]') && !this.readyToAdd) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.setAttribute('data-options-needed', true);
          this.sendAlgoliaATCEvent();
        }
      });

      this.addDelegatedClickListeners();
      this.createCustomEvents();
      
      poll(() => {
        return this.querySelector('[data-atc-button]');
      }, 10000, 150).then(() => {
        this.initProductForm();
        // any elements that might not exist yet when the ACE gets added to the DOM
        this.imagesWrapper = this.querySelector('[data-product-images-wrapper]');
        this.displayPrice = [...this.querySelectorAll('[data-display-price]')];
        this.displayOptions = this.querySelector('[data-display-options]');
        this.displayTitle = [...this.querySelectorAll('[data-display-title]')];
        this.colorTitle = [...this.querySelectorAll('[data-color-title')];
        this.mainSelect = this.querySelector('[data-main-select]');
        this.querySelector('[data-form-fieldset]')?.removeAttribute('disabled', true);
        this.quantityInput = this.querySelector('input[name=quantity]');
        this.currencySymbol = Shopify.currency.active == "EUR" ? "€" : "$";
        //if (screen.width > 768) this.desktopAccordions(); //You never know if they'll want it back
        //this.stickyATC(); //You never know if they'll want it back
        this.observeTruemedChanges();
        this.watchSwiperVideo();
        
        similarProducts({ similarSection: this.querySelector('[data-similar-products]'), similarList: this.querySelector('[data-similar-list]')})
      });
      
      window.addEventListener('loaded:product-form', () => {
        this.checkReadiness();
        const [colorOption] = this.selectedProduct.options_with_values.filter(option => option.name.toLowerCase().trim() === this.colorLabel);
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.filter(k => !colorOption?.values?.find(j => j === k))
            .every((x) => window.selectedOptionsToPersist?.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        this.populateSelectedProductOptions();
        this.swapOutATC();
      });
      
      const stickyObserver = new IntersectionObserver(([entry]) => {
        const buttons = document.querySelectorAll('button.kl-private-reset-css-Xuajs1');

        buttons.forEach((button) => {
          button.style.display = entry.isIntersecting ? 'none' : '';
        });
      });
      
      const stickyElement = document.querySelector('#StickyAddToCart');
      if (stickyElement) stickyObserver.observe(stickyElement);

      const judgeme_observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.target.classList.contains('jdgm-rev-widg')) {
            updateAverageRating(judgeme_observer);
          }
        }
      });

      const targetNode = document.querySelector('#judgeme_product_reviews');
      const config = {
        childList: true,
        subtree: true,
      };

      judgeme_observer.observe(targetNode, config);
    }
      
    initProductForm() {
      const thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      const [colorOption] = this.selectedProduct.options_with_values.filter(option => option.name.toLowerCase().trim() === this.colorLabel);

      if ([...new Set(thisOptionSet)].length >= (this.selectedProduct.options_with_values.length)) {
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.filter(k => !colorOption?.values?.find(j => j === k))
            .every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        if (this.currentVariant) {
          this.setOptionsToPersist();
          const sectionWrapper = this.querySelector('[data-section="product-form"]')
          persistOptionsFromWindow(sectionWrapper);
        }
        this.readyToAdd = true;
        this.expressPaymentWrapper?.classList.add('express-payment-pdp');
        this.mainSelect.value = this.currentVariant.id;
        this.checkReadiness();
        this.swapOutATC();
      } else {
        this.readyToAdd = false;      
        this.swapOutATC();
        this.expressPaymentWrapper?.classList.remove('express-payment-pdp');
      }      
      this.populateSelectedProductOptions();
      
      [...document.querySelectorAll('[data-show]')].filter(el => !el.closest('recommended-products')).forEach((el) => {
        if (Number(el.dataset.show) === Number(this.selectedProduct.id)) {
          el.style.display = null;
          if (el.closest('content-accordion')) {
            setTimeout(() => {
              this.querySelectorAll('[data-accordion-id].active [data-accordion-content]').forEach((contentElement) => {
                contentElement.style.setProperty('--accordion-content-height', `${contentElement.scrollHeight}px`)
              });
            }, 10);
          }
          if (el.querySelector('swiper-carousel')) {
            setTimeout(() => {
              el.querySelector('swiper-carousel')?.reinit();
            }, 10);
          }
          return;
        }
        el.style.display = 'none';
      });
    }

    swapStock(id){
      [...document.querySelectorAll('[data-variant-show]')].forEach((el) => {
        if (Number(el.dataset.variantShow) === Number(id)) {
          el.style.display = null;
          return;
        }
        el.style.display = 'none';
      });
    }
    
    addDelegatedClickListeners() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const currentUrl = new URL(window.location.href);

        const {
          action,
          productId,
          option,
          optionType,
          productHandle,
          index
        } = clickedElement.dataset;
                  
        switch (action) {
          case 'select-thumb':
            this.querySelectorAll('[data-action="select-thumb"].selected')
              .forEach((el) => {
                el.classList.remove('selected');
              });
            clickedElement.classList.add('selected');
            const swiper = document.querySelector('[data-mobile-image-loop]').swiper;
            swiper.slideTo(index)
          break;
          case 'product-select':
            if (productId === this.selectedProduct?.id) return;
            this.readyToAdd = false;
            this.selectedProduct = this.products.find(({ id }) => id === productId);
            this.currentVariant = null;
            if (this.quantityInput) this.quantityInput.value = 1
            
            if (this.sizeSelection && !this.currentVariant && this.readyToAdd) {
              this.currentVariant = this.selectedProduct.variants
                .find(({ options }) => {
                  return (
                    options.find((x) => x === this.sizeSelection)
                  )
                });
            }
            if (this.currentVariant) {
              const variantUrl = new URL(this.currentVariant.url, window.location.origin);
              const params = new URLSearchParams(currentUrl.search);
              variantUrl.searchParams.forEach((value, key) => params.set(key, value));
              variantUrl.search = params.toString();
              history.replaceState(this.selectedProduct.title, '', variantUrl);
            } else {
              const productURL = new URL(this.selectedProduct.url, window.location.origin);
              const params = new URLSearchParams(currentUrl.search);
              productURL.searchParams.forEach((value, key) => params.set(key, value));
              params.delete('variant');
              productURL.search = params.toString();
              history.replaceState(this.selectedProduct.title, '', productURL);
            }
            
            [...document.querySelectorAll('[data-show]')].filter(el => !el.closest('recommended-products')).forEach((el) => {
              if (Number(el.dataset.show) === Number(this.selectedProduct.id)) {
                el.style.display = null;
                if (el.closest('content-accordion')) {
                  setTimeout(() => {
                    this.querySelectorAll('[data-accordion-id].active [data-accordion-content]').forEach((contentElement) => {
                      contentElement.style.setProperty('--accordion-content-height', `${contentElement.scrollHeight}px`)
                    });
                  }, 10);
                }
                if (el.querySelector('swiper-carousel')) {
                  setTimeout(() => {
                    el.querySelector('swiper-carousel')?.reinit();
                  }, 10);
                }
                return;
              }
              el.style.display = 'none';
            });
            
            let productUpdate = this.currentVariant == null ? this.selectedProduct : this.currentVariant
            const sectionWrapper = this.querySelector('[data-section="product-form"]')
            sectionWrapper.querySelector('[data-action="add-to-cart"]')?.classList.add('loading');
            const sectionInnerHTML = document.getElementById(`linked-product${productHandle}`).innerHTML;
            sectionWrapper.innerHTML = sectionInnerHTML;
            persistOptionsFromWindow(sectionWrapper);
            this.mainSelect.innerHTML = `${this.selectedProduct.variants.map((variant) => `
              <option 
                value="${variant.id}"
                ${variant.id === this.currentVariant?.id ? 'selected="selected"' : ''}
              >
                ${variant.title} - ${variant.price_money}
              </option>
            `).join('')}`;   

            setTimeout(() => {
              if (this.currentVariant) this.swapStock(this.currentVariant.id);
            }, 50);
            
            this.initProductForm();
            
            this.populateSelectedProductImages();
            this.populateSelectedProductPrice(productUpdate);
            this.displayTitle.forEach(el => el.innerHTML = this.selectedProduct.title.split(' - ')[0]);
            this.colorTitle.forEach(el => el.innerHTML = ': ' + this.selectedProduct.title.split(' - ')[1]);
            this.watchSwiperVideo();
          break;                            
          case 'option-choice':
            if (!option) {
              console.error('Input with [data-action="option-choice"] is missing a [data-option="value"] attr');
              return;
            }
            
            this.setOptionsToPersist();
            const optionIndex = this.selectedProduct.options_with_values
              .findIndex(({ values }) => values.find(x => x === option));
            let thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')]
              .map(({ value }) => value);
            thisOptionSet[optionIndex] = option;
            
            if (optionType.toLowerCase().includes('size')) {
              this.sizeSelection = option;
            }
            
            this.querySelector(`[data-${optionType.toLowerCase()}-title`).innerHTML = ` ${option}`;
            
            const [colorOption] = this.selectedProduct.options_with_values.filter(
              option => option.name.toLowerCase().trim() === this.colorLabel
            );
                        
            if ([...new Set(thisOptionSet)].length >= (this.selectedProduct.options_with_values.length)) {
              this.currentVariant = this.selectedProduct.variants.find(({ options }) => 
                options.filter(k => !colorOption?.values?.find(j => j === k))
                  .every(x => thisOptionSet.find(y => y?.toLowerCase().trim() === x?.toLowerCase().trim()))
              );
              
              this.readyToAdd = true;
              this.expressPaymentWrapper?.classList.add('express-payment-pdp');
            } else {
              this.readyToAdd = false;
              this.expressPaymentWrapper?.classList.remove('express-payment-pdp');
            }
            
            this.populateSelectedProductOptions();
            this.swapOutATC();
            setTimeout(() => {
              if (this.currentVariant) this.swapStock(this.currentVariant.id);
            }, 50);
            window.dispatchEvent(this.variantUpdatedEvent);
            
            if (!this.currentVariant) return;
            this.mainSelect.value = this.currentVariant.id;
            
            const variantUrl = new URL(this.currentVariant.url, window.location.origin);
            const params = new URLSearchParams(currentUrl.search);
            variantUrl.searchParams.forEach((value, key) => params.set(key, value));
            variantUrl.search = params.toString();
            
            history.replaceState(this.selectedProduct.title, '', variantUrl.toString());
            
            const variantImage = [...this.imagesWrapper?.querySelectorAll('[data-variants]') ?? []]
              .find(({ dataset: { variants } }) => variants.includes(this.currentVariant.id));
            
            if (variantImage) {
              this.imagesWrapper.insertBefore(variantImage, wrapper.firstChild);
            }
            
          break;
          case 'scroll-to-reviews':
            const reviewsEl = document.getElementById('judgeme_product_reviews');
            const headerElHeight = document.querySelector('header')?.offsetHeight;

            if (!reviewsEl || !headerElHeight) return;
            const reviewsOffsetTop = reviewsEl.offsetTop - headerElHeight;
            window.scrollTo({ behavior: 'smooth', top: reviewsOffsetTop });
          break;
          case 'select-pack':
            this.quantityInput.value = clickedElement.value
            const packLabel = this.querySelector('[data-bundle-label]');
            packLabel.innerHTML = `: ${clickedElement.dataset.label}`


            this.displayPrice.forEach(el => {
              el.innerHTML = clickedElement.dataset.price > clickedElement.dataset.discountPrice
                ? `
                  <span data-sale-price class="text-thunderbird	empty:hidden">${clickedElement.dataset.discountPrice}</span>
                  <span data-compare-price class="line-through text-primaryDark empty:hidden">${clickedElement.dataset.price}</span>`
                : 
                  `<span data-price class="text-primaryDark empty:hidden">${clickedElement.dataset.price}</span>`;
                parseInt(clickedElement.dataset.discount) > 0 ?  el.insertAdjacentHTML('beforeend', `<span class="text-primaryBrand">${clickedElement.dataset.discount}% bundle savings</span>`) : ``
            });
          break;
          default: break;
        }
      })
    }
    
    setOptionsToPersist() {
      window.selectedOptionsToPersist = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
    }
    
    checkReadiness() {
      const [colorOption] = this.selectedProduct.options_with_values.filter(option => option.name.toLowerCase().trim() === this.colorLabel);
      const thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      const currentUrl = new URL(window.location.href);

      this.currentVariant = this.selectedProduct.variants
        .find(({ options }) => options.filter(k => !colorOption?.values?.find(j => j === k))
          .every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
          
      if (this.currentVariant) {
        this.mainSelect.value = this.currentVariant.id;
        const variantUrl = new URL(this.currentVariant.url, window.location.origin);
        const params = new URLSearchParams(currentUrl.search);
        variantUrl.searchParams.forEach((value, key) => params.set(key, value));
        variantUrl.search = params.toString();
        history.replaceState(this.selectedProduct.title, '', variantUrl);
      }
            
      if (!this.selectedProduct || !this.currentVariant) {
        this.readyToAdd = false;
        return;
      }
      
      if ([...new Set(thisOptionSet)].length >= (this.selectedProduct.options_with_values.length)) {
        this.readyToAdd = true;
        this.expressPaymentWrapper?.classList.add('express-payment-pdp');
      } else {
        this.readyToAdd = false;  
        this.expressPaymentWrapper?.classList.remove('express-payment-pdp');    
      }
    }
    
    createCustomEvents() {
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
      this.variantUpdatedEvent = new CustomEvent('coco-shuffle:variant-updated', {});
    }
    
    loadImage(media, i, thumb) {
      // is there a template defined?
      const template = this.querySelector('[data-template="product-image"]')?.innerHTML.toString();
      const { alt, src, variants } = media;
      
      if (media.media_type === 'video') {
        const { alt, poster, sources } = media;
        const source = sources.find(x => x.format === 'mp4');
        let template = false;
        if (!source) return;
        if (thumb){
          template = this.querySelector('[data-template="product-video-thumb"]')?.innerHTML.toString();
        } else {
          template = this.querySelector('[data-template="product-video"]')?.innerHTML.toString();
        }
        let templateString = template.replaceAll('{poster}', poster).replaceAll('{alt}', alt).replaceAll('{source}', source.url).replaceAll('{mime_type}', source.mime_type).replaceAll('{index}', i);
        if (media.alt.includes('autoplay')) {
          templateString = templateString.replaceAll('autoplay="autoplay"', 'autoplay');
        } else {
          templateString = templateString.replaceAll('autoplay="autoplay"', '');
        }

        return templateString; 
      }
      
      if (!template) { 
        return `
          <img height="1200" width="1200" sizes="(min-width:768px) 600px, (min-width:1600px) 800px, (min-width:2000px) 1200px" alt="${alt ? alt : this.selectedProduct.title}" src="${src}">
        `; 
      }
      
      const templateString = template.replaceAll('{src}', src).replaceAll('{alt}', alt).replaceAll('{variants}', variants).replaceAll('{classes}', '').replaceAll('{index}', i);
      return templateString;
    }
  
    swapOutATC() {
      const atcButton = this.querySelector('[data-action="add-to-cart"]');
      const oosButton = this.querySelector('[data-out-of-stock]');
      const bisButtons = this.querySelectorAll('[data-notify-me]');
      const stickyButton = this.querySelector('[data-sticky-atc-button]');
            
      if (!this.readyToAdd) {
        // if (window?.selectedOptionsToPersist) this.setAttribute('data-options-needed', true);
        const allNeededOptions = [...this.querySelectorAll('div[data-option-type]:not(:has(input:checked)):not(.hidden)')]?.map(el => el.dataset.optionType);
        atcButton.innerText = `${atcButton.dataset?.selectPrefix || 'Select'} ${allNeededOptions.join(' & ')}`;
        atcButton.removeAttribute('disabled');
        atcButton.classList.add('needs-options');
        return;
      }
      
      this.removeAttribute('data-options-needed');
      atcButton.classList.remove('needs-options');
      
      if (!this.currentVariant) {
        atcButton.setAttribute('disabled', true);
        if (!oosButton) return;
        
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
        oosButton.classList.add('peer-disabled:block');
        oosButton.innerHTML = "Unavailable";
        return;
      }
      
      atcButton.innerText = atcButton.dataset?.addText || 'Add to Cart';
      bisButtons.forEach(button => button.setAttribute('data-variant-id', this.currentVariant.id));

      if (!this.currentVariant.available) this.expressPaymentWrapper?.classList.remove('express-payment-pdp');

      this.currentVariant.available ? atcButton.removeAttribute('disabled') : atcButton.setAttribute('disabled', true);
      if (stickyButton) this.currentVariant.available ? stickyButton.innerHTML = "Add to cart" : stickyButton.innerHTML = "Notify me when restocked";
      oosButton.innerHTML = "Out of Stock";

      if (this.currentVariant) {
        oosButton.dataset.variantId = this.currentVariant.id;
      }

      const hideBis = !!this.selectedProduct.tags.find(x => x === 'hide_bis');
      if (hideBis) {
        oosButton?.classList.add('peer-disabled:block');
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
      } else {
        oosButton?.classList.remove('peer-disabled:block');
        bisButtons.forEach(button => button.classList.add('peer-disabled:block'));
      }
      if (!this.querySelector('[data-similar-products]')) return
      this.currentVariant.available 
        ? this.querySelector('[data-similar-products]').classList.add('hidden') 
        : similarProducts({ 
          size: this.currentVariant.option1, 
          width: this.currentVariant.option2,
          similarSection: this.querySelector('[data-similar-products]'),
          similarList: this.querySelector('[data-similar-list]')
        })
    }

    desktopAccordions() {
      const deskOpen = this.querySelectorAll('[data-desk-open]');
      deskOpen.forEach(accordion => {
        accordion.click()
      });
    }

    stickyATC(){ 
      const formButtons = this.querySelector('[data-atc-button]');
      const productForm = this.querySelector('#productForm').offsetTop
      const headerOffset = document.querySelector('site-header').offsetHeight;
      const stickyATC = this.querySelector('[data-sticky-atc]');
      window.addEventListener('scroll', () => {
        if (formButtons.getBoundingClientRect().top <= 0) {
          stickyATC.classList.remove('opacity-0', 'translate-y-full');
        } else {
          stickyATC.classList.add('opacity-0', 'translate-y-full');
        }
      });
      stickyATC.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
          top: productForm - headerOffset,
          behavior: "smooth",
        });
      })
    }

    observeTruemedChanges() {
      const truemed_container = document.querySelector('[data-truemed-container]');
      const truemed_skeleton = document.querySelector('[data-truemed-skeleton]');

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            truemed_skeleton.classList.add('hidden');
          }
        }
      });

      observer.observe(truemed_container, {
        childList: true,
        subtree: true, 
      });
    }

    watchSwiperVideo() {
      const miniVideo = document.querySelector('[data-mini-video]');
      const swipers = document.querySelectorAll('swiper-carousel[data-mobile-image-loop]');

      swipers.forEach((swiper) => {
        const checkActiveSlide = () => {
          const active = swiper.querySelector('.swiper-slide-active');
          if (!active) return;

          const hasVideo = active.querySelector('video') !== null;
          if (hasVideo) {
            miniVideo?.classList.add('opacity-0', 'pointer-events-none');
          } else {
            miniVideo?.classList.remove('opacity-0', 'pointer-events-none');
          }
        };

        checkActiveSlide();

        const observer = new MutationObserver(checkActiveSlide);
        swiper.querySelectorAll('.swiper-slide').forEach(slide => {
          observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
        });

      });
    }
  }
    
  customElements.define('coco-shuffle', CocoShuffle);
}